import { MsgLiquidStakeSDKType as DymMsgLiquidStake } from 'stridejs/dist/types/codegen/stride/stakedym/tx'
import { MetaDataHandlerParameters } from './types'
import { DYM_CHAIN_INFO } from '@/config'
import { isSelectedCoinDenom } from '@/wallet-utils'
import { assert } from '@/utils'

const handleDymLiquidStake = ({
  response,
  message,
  strideAddress,
  denom
}: MetaDataHandlerParameters<DymMsgLiquidStake>): boolean => {
  // We'll exclude liquid stake tx that was committed but failed and
  // ones that did not come from the selected chain. We'll also make sure
  // to only display this transaction if DYM is the selected chain
  assert(isSelectedCoinDenom(DYM_CHAIN_INFO.stakeCurrency.coinDenom), 'DYM is not a SelectedCoinDenom')
  return response.code === 0 && message.staker === strideAddress && denom === DYM_CHAIN_INFO.stakeCurrency.coinDenom
}

export { handleDymLiquidStake }
